import { useAppDispatch, useAppSelector } from "../../app/store/hooks";

import { closeSheetById, pushSheet, updateSheetChildren, updateSheetState } from "./slice";
import { ReactNode } from "react";

export const useSheets = () => {
    const dispatch = useAppDispatch();
    const selector = useAppSelector(state => state.sheets);

    return {
        sheets: selector,
        updateSheets: (content: ReactNode, width?: string | number) =>
            dispatch(updateSheetChildren({ content, width })),
        setOpenSheets: (payload: boolean) => dispatch(updateSheetState(payload)),
        pushToStack: (content: ReactNode, width: string, id?: string) => {
            dispatch(
                pushSheet({
                    content,
                    width: width || "990px",
                    id,
                })
            );

            return id;
        },
        closeSheetFromStack: (id?: string) => {
            dispatch(closeSheetById(id));
        },
        getCurrentStack: () => {
            return selector.sheetStack.filter(
                (sheet, index, self) => index === self.findIndex(s => s.id === sheet.id)
            );
        },
    };
};
